<template>
    <div class="bg">
        <el-header style="height: 4%; display: flex;justify-content: space-between;">
            <div style="display: flex;gap:10px;">
                <img src="@/assets/favicon.png" alt="">
                <div class="header-text-left">凌丰供应商系统</div>
                <div class="pe-header-text">加工送货单（总览）</div>
            </div>
            <div style="width: 320px;">
                <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }}) </div>
                <div class="header-right" style="color: #fff;">{{ homeDate }}</div>
            </div>
        </el-header>
        <div class="proc_nav">
            <div class="nav_left">
                <el-descriptions title="" :column="4" border>
                    <el-descriptions-item label="送货单编号" :contentStyle="{ width: '200px', }" :labelStyle="labelStyle">
                        <el-input style="width: 100%;font-size: 14px;" clearable @change="search" v-model="search_obj.formCode" placeholder="请输入单据编号" size="small">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="项目名称" contentStyle='width:250px' :labelStyle="labelStyle">
                        <el-input style="width: 100%;font-size: 14px;" clearable @change="search" v-model="search_obj.projectName" placeholder="请输入项目名称" size="small">
                        </el-input>
                    </el-descriptions-item>
                    <!-- <el-descriptions-item label="状态" contentStyle='width :200px' :labelStyle="labelStyle">
                        <el-select v-model="search_obj.status" filterable placeholder="请选择状态" size="small"
                            style="width:100%" value-key="id" clearable @change="search">
                            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-descriptions-item> -->
                    <el-descriptions-item label="合同号" contentStyle='width :200px' :labelStyle="labelStyle">
                        <el-select style="width: 100%;font-size: 14px;" size="small" clearable @change="search" v-model="search_obj.projectId" filterable placeholder="输入并选择合同号"
                            default-first-option remote :remote-method="async_projectId" :loading="loading2">
                            <el-option v-for="item in project_options" :key="item.id" :label="item.trackNumber" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item label="状态" contentStyle='width :200px' :labelStyle="labelStyle">
                        <el-radio-group v-model="search_obj.status" size="mini" @change="search">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button label="0">申请中</el-radio-button>
                            <el-radio-button label="1">通过</el-radio-button>
                            <el-radio-button label="-1">驳回</el-radio-button>
                        </el-radio-group>
                    </el-descriptions-item>
                    <el-descriptions-item label="组件名称" contentStyle="width: 200px" :labelStyle="labelStyle">
                        <el-input style="width: 100%;font-size: 14px;" clearable @change="search" v-model="search_obj.headMaterial" placeholder="请输入组件名称" size="small">
                        </el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="零件名称" contentStyle='width :200px' :labelStyle="labelStyle">
                        <div style="display: flex;">
                            <el-select style="width: 100%;font-size: 14px;" size="small" clearable @change="search" v-model="search_obj.materialId" filterable
                                placeholder="输入并选择加工件" default-first-option remote :remote-method="async_procMaterial" :loading="loading2" value-key="id">
                                <el-option v-for="item in procMaterial_options" :key="item.id" :label="item.materialName + '--' + item.materialCode" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="审核状态" contentStyle='width :200px' :labelStyle="labelStyle">
                        <el-radio-group v-model="search_obj.isAudit" size="mini" @change="search">
                            <el-radio-button :label="null">全部</el-radio-button>
                            <el-radio-button :label="false">我的待审</el-radio-button>
                            <el-radio-button :label="true">已审</el-radio-button>
                        </el-radio-group>
                    </el-descriptions-item>
                    <el-descriptions-item label="其它条件" contentStyle='width :250px' :labelStyle="labelStyle">
                        <div style="width: 100%;text-align:center;line-height: 18px;">
                            <el-link type="primary" @click="other_show = true">展开</el-link>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="nav_right">
                <div style="display: flex;">
                    <el-button size="small" type="primary" @click="search">搜索</el-button>
                    <el-button icon="el-icon-printer" plain size="small" type="primary" @click="printLabelCard">打印标识卡</el-button>
                    <el-button icon="el-icon-download" plain size="small" title="导出对账单" type="warning" @click="exportAll_show = true">导出对账单</el-button>
                </div>
            </div>
        </div>
        <div class="table-body">
            <el-table ref="procTable" :data="table_data" border stripe height="100%" :header-row-style="{ height: '0' }" :header-cell-style="{
                    background: '#78b5ec',
                    color: '#000',
                    padding: '0',
                    fontWeight: '400',
                    textAlign: 'center',
                }" :row-style="{ height: '35px' }" :cell-style="{ padding: '2px 0' }" row-key="id" v-loading="table_loading"
                :row-class-name="rowClassName" @selection-change="handleSelectionChange" @row-click="handleRowClick" @mousedown.native="onTableMouseDown">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column label="送货单编号" prop="formCode" width="120" align="left" show-overflow-tooltip sortable></el-table-column>
                <el-table-column label="建单日期" prop="createTime" width="100" align="center" sortable>
                    <template slot-scope="ss">
                        {{ formatDateYear(ss.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="审批日期" prop="auditTime" width="100" align="center" sortable>
                    <template slot-scope="ss">
                        {{ formatDateYear(ss.row.auditTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="完成日期" prop="finishTime" width="100" align="center" sortable>
                    <template slot-scope="ss">
                        {{ formatDateYear(ss.row.finishTime) }}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="状态" prop="" width="180" align="left" show-overflow-tooltip
                    sortable></el-table-column> -->
                <el-table-column label="合同号" prop="project.trackNumber" width="180" align="left" show-overflow-tooltip sortable></el-table-column>
                <el-table-column label="项目名称" prop="projectName" width="250" align="left" show-overflow-tooltip sortable></el-table-column>
                <el-table-column label="加工商" prop="procSupplier.supplierName" min-width="150" align="left" show-overflow-tooltip sortable></el-table-column>
                <el-table-column label="单据状态" prop="status" width="110" align="center" show-overflow-tooltip sortable>
                    <template slot-scope="ss">
                        <div :style="{ color: ss.row.status == 0 ? 'orange' : ss.row.status == 1 ? 'green' : 'red' }">
                            {{ ss.row.status == 0 ? '申请中' : ss.row.status == 1 ? '通过' : ss.row.status == -1 ? '驳回' : '' }}
                            <el-popover v-if="ss.row.status == -1" placement="top" trigger="hover" width="320" @show="loadRejectReason(ss.row.formCode)">
                                <div class="reject-reason-content">{{ rejectReasonText(ss.row.formCode) }}</div>
                                <i slot="reference" class="el-icon-warning-outline reject-reason-icon" title="查看驳回原因"></i>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="审批进度" prop="auditProgress" width="150" sortable>
                    <template slot-scope="ss">
                        <div class="audit-progress-cell">
                            <el-progress :percentage="auditPercent(ss.row)" :color="auditProgressColor(ss.row)" :stroke-width="10" :show-text="false"></el-progress>
                            <span class="audit-progress-text" :style="{ color: auditProgressColor(ss.row) }">{{
                                auditPercent(ss.row) }}%</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="附件" prop="" width="80" align="center">
                    <template slot-scope="ss">
                        <div v-if="ss.row.commonFileList && ss.row.commonFileList.length > 0">
                            <el-dropdown trigger="click" :ref="`dropdown-${ss.row.formCode}`" placement="bottom-start" :hide-on-click="false">
                                <el-button type="text" size="media" @click.stop style="padding: 0;">
                                    查看({{ ss.row.commonFileList.length }})
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="(file, index) in ss.row.commonFileList" :key="index" class="file-item" @click.native="previewFile(file, ss.row)">
                                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;border-bottom: solid 1px #ccc;">
                                            <span style="flex: 1; text-align: left; margin-right: 30px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                                :title="`上传时间：${file.uploadTime}`">
                                                {{ file.originalName }} ({{ formatFileSize(file.size) }})
                                            </span>
                                            <div style="display: flex; gap: 10px;">
                                                <el-link type="primary" size="mini" v-if="countFileType(file.originalName) == '图片' || countFileType(file.originalName) == 'PDF'"
                                                    title="预览">
                                                    <i class="el-icon-view"></i>预览
                                                </el-link>
                                                <el-link type="success" size="mini" @click.stop="downloadFile(file)" title="下载">
                                                    <i class="el-icon-download"></i>下载
                                                </el-link>
                                                <el-link type="danger" size="mini" @click.stop="delFile(file)" title="删除">
                                                    <i class="el-icon-delete"></i>删除
                                                </el-link>
                                            </div>
                                        </div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="单据金额" prop="totalPrice" width="100" align="center" sortable></el-table-column>
                <el-table-column label="数量" prop="qty" width="90" align="center" sortable></el-table-column>
                <el-table-column label="签收" prop="arrivedQty" width="90" align="center" sortable></el-table-column>
                <el-table-column align="center" label="操作" width="270">
                    <template slot-scope="ss">
                        <div style="display: flex;gap: 10px;justify-content: center;">
                            <el-link type="primary" @click="openUpload(ss.row)">上传附件</el-link>
                            <el-link type="primary" @click="gotoItem(ss.row)">详情</el-link>
                            <el-link v-if="ss.row.isAudit!==null && !ss.row.isAudit && roleName == '管理员'" type="success" @click="audit(ss.row, 1, '')">批准</el-link>
                            <el-link v-if="ss.row.isAudit!==null && !ss.row.isAudit && roleName == '管理员'" type="danger" @click="perDisApprove(ss.row)">驳回</el-link>
                            <el-link v-if="ss.row.status === 0 || ss.row.status === -1" type="danger" @click="delForm(ss.row)">删除</el-link>
                            <el-link v-if="ss.row.status === 0 && roleName == '供应商'" type="warning" @click="urge(ss.row)">催审核</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-footer">
            <el-pagination background layout="sizes, prev, pager, next, total" :total="total" @size-change="handleSizeChange" @current-change="change_data"
                :current-page="search_obj.currentPage" :page-size="search_obj.pageSize" :page-sizes="[10, 30, 50, 100, 200, 300, 400, 500]">
            </el-pagination>
        </div>
        <el-footer class="page_footer">© 2024 LINKFAIRTECH 版权所有</el-footer>

        <el-dialog title="其它搜索条件" :visible.sync="other_show" width="30%">
            <el-form ref="other_search_form" :model="search_obj">
                <el-form-item label="建单日期" label-width="80px" prop="createTime">
                    <el-date-picker v-model="dateRange1" type="datetimerange" align="right" style="font-size: 14px;width: 80%;" @change="search" start-placeholder="开始日期"
                        end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" size="small">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="完成日期" label-width="80px" prop="deadline">
                    <el-date-picker v-model="dateRange2" type="datetimerange" align="right" style="font-size: 14px;width: 80%;" @change="search" start-placeholder="开始日期"
                        end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" size="small">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="加工商" label-width="80px" prop="deadline" v-if="roleName != '供应商'">
                    <el-select style="width: 80%;font-size: 14px;" size="small" clearable v-model="search_obj.supplierId" @change="search" filterable placeholder="输入并选择加工商"
                        default-first-option remote :remote-method="async_procSupplier" :loading="loading2" value-key="id">
                        <el-option v-for="item in procSupplier_options" :key="item.id" :label="item.supplierName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="other_show = false">取 消</el-button>
                <el-button type="success" plain size="small" @click="other_search">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="批量导出对账单" :visible.sync="exportAll_show" width="30%">
            <el-form ref="exportAll" :model="exportAll_data" :rules="rules">
                <el-form-item label="签收时间范围" label-width="100px" prop="dateRange">
                    <el-date-picker v-model="dateRange3" type="datetimerange" align="right" style="font-size: 14px;width: 100%;" start-placeholder="开始日期" end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" size="">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="供应商" label-width="100px" v-if="roleName != '供应商'" prop="supplierId">
                    <el-select style="width: 100%;font-size: 14px;" size="" clearable filterable remote v-model="exportAll_data.supplierId" placeholder="选择供应商"
                        :remote-method="async_procSupplier" :loading="loading2" default-first-option>
                        <el-option v-for="item in procSupplier_options" :key="item.id" style="width:100%" :label="item.supplierName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="exportAll_show = false">取消</el-button>
                <el-button type="success" plain size="small" @click="exportAll_submit">批量导出</el-button>
            </div>
        </el-dialog>

        <uploadFile :uploadShow.sync="uploadShow" :currentRow="currentRow" tableName="proc_sent_form" @uploadClose="uploadClose" />
        <viewFileMin :file="currentViewFile" :visible="viewOffice" @updateVisible="updateVisible"></viewFileMin>
        <imageView :img_show.sync="img_show" :fileName="currentFileName" :filePath="currentFilePath" @imageClose="imageClose">
        </imageView>

        <el-dialog title="驳回意见" :visible.sync="disApprove_show" width="30%">
            <el-input type="textarea" rows="4" v-model="disApproveRemark" placeholder="请输入驳回意见" size="small"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="disApprove_show = false">取 消</el-button>
                <el-button type="success" plain size="small" @click="disApprove_submit">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 鼠标框选表格时的选区矩形 -->
        <div class="drag-select-box" v-if="dragBox" :style="dragBox"></div>
    </div>
</template>

<script>
import { get_procSupplier, formatDateYear, get_procMaterial, get_project } from "@/utils/func";
import { getOutSourceSendApi, getOutSourceSendItemApi, delProcSendApi, approvalApi, auditApi, auditProgressApi, urgeApi } from "@/Api/procApi";
import * as fileApi from "@/Api/fileApi";
import { exportExcel3 } from "@/utils/utils";
import uploadFile from "@/components/uploadFile.vue";
import viewFileMin from "@/components/viewFileMin.vue";
import imageView from "@/components/imageView.vue";
export default {
    name: "procSend",
    components: {
        uploadFile,
        viewFileMin,
        imageView,
    },
    data() {
        return {
            timer: "",
            homeDate: "",
            userNme: sessionStorage.getItem("userName"),
            labelStyle: { width: "70px", textAlign: "center", color: "#4d4d4d", backgroundColor: "#fff" },
            search_obj: {
                formCode: "",
                materialId: "",
                projectId: "",
                supplierId: "",
                headMaterial: "",
                projectName: "",
                status: "",
                startCreateTime: "",
                endCreateTime: "",
                startFinishTime: "",
                endFinishTime: "",
                isAudit: sessionStorage.getItem("roleName") == "管理员" ? false : null,
                pageSize: 50,
                currentPage: 1,
            },
            total: 30,
            gettable_params: {
                pageSize: 30,
                currentPage: 1,
                keyword: "",
            },
            header: {
                headers: { token: sessionStorage.getItem("token") },
            },
            table_data: [],
            table_loading: false,
            genData: [],
            totalPage: 30,
            useDate: "",
            loading2: false,
            project_options: [],
            procMaterial_options: [],
            procSupplier_options: [],
            addname_visiable: false,
            status_list: ["未发货", "部分发货", "在途", "部分签收", "签收完成"],
            select_alias: "",
            roleName: sessionStorage.getItem("roleName"),
            flag: false,

            statusList: [
                { id: 1, name: "保存", color: "blue" },
                { id: 2, name: "提交", color: "#ef7b15" },
                { id: 4, name: "审核", color: "#12CAD6" },
                { id: 8, name: "签收", color: "green" },
                { id: -4, name: "不通过", color: "red" },
            ],
            other_show: false,

            exportAll_show: false,
            rules: {
                supplierId: [{ required: true, message: "请选择供应商", trigger: ["blur", "change"] }],
            },
            exportAll_data: {
                startCreateTime: "",
                endCreateTime: "",
                supplierId: "",
                pageSize: 9999,
                currentPage: 1,
            },

            uploadShow: false,
            currentRow: {},
            currentViewFile: {},
            viewOffice: false,
            img_show: false,
            currentFileName: "",
            currentFilePath: "",
            disApprove_show: false,
            disApproveRemark: "",
            //驳回原因缓存（formCode -> remark）
            rejectReasonMap: {},
            //正在加载驳回原因的单据（formCode -> true），避免重复请求
            rejectReasonLoading: {},

            //已勾选的行（用于行高亮）
            selectedRows: [],
            //鼠标框选状态
            dragStart: null,
            dragMoved: false,
            dragBox: null,
            justDragged: false,
        };
    },
    computed: {
        dateRange1: {
            get() {
                return [this.search_obj.startCreateTime, this.search_obj.endCreateTime];
            },
            set(value) {
                if (value == null) {
                    this.search_obj.startCreateTime = "";
                    this.search_obj.endCreateTime = "";
                } else {
                    this.search_obj.startCreateTime = value[0];
                    this.search_obj.endCreateTime = value[1];
                }
            },
        },
        dateRange2: {
            get() {
                return [this.search_obj.startFinishTime, this.search_obj.endFinishTime];
            },
            set(value) {
                if (value == null) {
                    this.search_obj.startFinishTime = "";
                    this.search_obj.endFinishTime = "";
                } else {
                    this.search_obj.startFinishTime = value[0];
                    this.search_obj.endFinishTime = value[1];
                }
            },
        },
        dateRange3: {
            get() {
                return [this.exportAll_data.startCreateTime, this.exportAll_data.endCreateTime];
            },
            set(value) {
                if (value == null) {
                    this.exportAll_data.startCreateTime = "";
                    this.exportAll_data.endCreateTime = "";
                } else {
                    this.exportAll_data.startCreateTime = value[0];
                    this.exportAll_data.endCreateTime = value[1];
                }
            },
        },
    },
    methods: {
        //催审核
        urge(row) {
            this.$confirm("确认催审核吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    urgeApi({ formCode: row.formCode }, this)
                        .then(() => {
                            this.$message.success("成功发送消息通知审核人员");
                        })
                        .catch(() => {
                            this.$message.error("发送消息通知审核人员失败");
                        });
                })
                .catch(() => {});
        },
        perDisApprove(row) {
            this.currentRow = structuredClone(row);
            this.disApprove_show = true;
        },
        disApprove_submit() {
            if (!this.disApproveRemark) {
                this.$message.error("请输入驳回意见");
                return;
            }
            this.audit(this.currentRow, 2, this.disApproveRemark);
        },
        audit(row, result, remark) {
            // if (row.status == status) {
            //     this.$message.error(`已经是${status == -1 ? '驳回' : '批准'}状态，无需重复操作`);
            //     return
            // }
            this.$confirm(`确认${result == 2 ? "驳回" : "批准"}吗？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let searchObj = {
                        formCode: row.formCode,
                        pageSize: 999,
                        currentPage: 1,
                    };
                    getOutSourceSendItemApi(searchObj, this)
                        .then((res) => {
                            let submitData = res.records.map((item) => {
                                return {
                                    sentFormId: item.id,
                                    result: result,
                                    remark: remark,
                                };
                            });
                            auditApi(submitData, this)
                                .then(() => {
                                    this.$message.success("审批成功");
                                    this.get_data();
                                })
                                .catch(() => {
                                    this.$message.error("审批失败");
                                });
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        //加载驳回原因：审批进度中取 result 值为 2 的记录，其 remark 即为驳回原因
        loadRejectReason(formCode) {
            if (!formCode || this.rejectReasonMap[formCode] !== undefined || this.rejectReasonLoading[formCode]) return;
            this.rejectReasonLoading[formCode] = true;
            auditProgressApi({ formCode }, this)
                .then((res) => {
                    const list = res || [];
                    let remark = "";
                    //倒序查找，优先取最近一次的驳回记录
                    for (let i = list.length - 1; i >= 0; i--) {
                        if (list[i].result == 2) {
                            remark = list[i].remark || "";
                            break;
                        }
                    }
                    this.$set(this.rejectReasonMap, formCode, remark);
                })
                .catch(() => {})
                .finally(() => {
                    delete this.rejectReasonLoading[formCode];
                });
        },
        //悬浮气泡显示的文案
        rejectReasonText(formCode) {
            if (this.rejectReasonMap[formCode] !== undefined) {
                return this.rejectReasonMap[formCode] || "暂无驳回原因";
            }
            return "驳回原因加载中...";
        },
        updateVisible(e) {
            this.viewOffice = e;
            this.$nextTick(() => {
                this.$refs[`dropdown-${this.currentRow.formCode}`].show();
            });
        },
        //关闭查看文件弹窗
        imageClose() {
            this.img_show = false;
            this.$nextTick(() => {
                this.$refs[`dropdown-${this.currentRow.formCode}`].show();
            });
        },
        //打开上传文件弹窗
        openUpload(row) {
            this.currentRow = structuredClone(row);
            this.uploadShow = true;
        },
        //关闭上传文件弹窗
        uploadClose() {
            this.uploadShow = false;
            this.get_data();
        },
        formatDateYear,
        //审批进度百分比（0~1 转 0~100）
        auditPercent(row) {
            return Math.round((row.auditProgress || 0) * 100);
        },
        //审批进度条颜色
        auditProgressColor(row) {
            const p = this.auditPercent(row);
            if (p >= 100) return "#67C23A";
            if (p === 0) return "#C0C4CC";
            return "#12b4bd";
        },
        //显示时间
        showTime() {
            this.timer = setInterval(() => {
                this.homeDate = this.$getTime();
            }, 1000);
        },
        get_data() {
            getOutSourceSendApi(this.search_obj, this)
                .then((res) => {
                    this.table_data = res.records;
                    this.total = res.total;
                })
                .catch(() => {});
        },
        //勾选变化的行高亮
        rowClassName({ row }) {
            return this.selectedRows.includes(row) ? "selected-row" : "";
        },
        handleSelectionChange(rows) {
            this.selectedRows = rows;
        },
        //点击行切换勾选状态（排除勾选框与操作列等交互元素）
        handleRowClick(row, column, event) {
            if (this.justDragged) return;
            if (column && column.type === "selection") return;
            const target = event && event.target;
            if (
                target &&
                target.closest &&
                target.closest("a, button, input, .el-link, .el-button, .el-dropdown, .el-checkbox, .el-popover__reference, .el-table__expand-icon")
            ) {
                return;
            }
            this.$refs.procTable.toggleRowSelection(row);
        },
        //按住鼠标左键准备框选（仅在表格内容区、非交互元素上触发）
        onTableMouseDown(e) {
            if (e.button !== 0 || !this.$refs.procTable) return;
            const target = e.target;
            if (
                target.closest &&
                target.closest("a, button, input, .el-link, .el-button, .el-dropdown, .el-checkbox, .el-popover__reference, .el-table__expand-icon")
            ) {
                return;
            }
            const wrapper = this.$refs.procTable.$el.querySelector(".el-table__body-wrapper");
            if (!wrapper || !wrapper.contains(target)) return;
            //必须从数据单元格开始拖拽，避免与滚动条、表头等区域冲突
            if (!target.closest(".el-table__body td")) return;
            e.preventDefault();
            this.dragStart = { x: e.clientX, y: e.clientY };
            this.dragMoved = false;
            document.addEventListener("mousemove", this.onTableMouseMove);
            document.addEventListener("mouseup", this.onTableMouseUp);
        },
        onTableMouseMove(e) {
            if (!this.dragStart) return;
            const dx = e.clientX - this.dragStart.x;
            const dy = e.clientY - this.dragStart.y;
            if (!this.dragMoved && Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
            this.dragMoved = true;
            this.dragBox = {
                left: Math.min(this.dragStart.x, e.clientX) + "px",
                top: Math.min(this.dragStart.y, e.clientY) + "px",
                width: Math.abs(dx) + "px",
                height: Math.abs(dy) + "px",
            };
        },
        //松开鼠标：与选框相交的行全部勾选
        onTableMouseUp(e) {
            document.removeEventListener("mousemove", this.onTableMouseMove);
            document.removeEventListener("mouseup", this.onTableMouseUp);
            if (!this.dragStart) return;
            const start = this.dragStart;
            const moved = this.dragMoved;
            this.dragStart = null;
            this.dragMoved = false;
            this.dragBox = null;
            if (!moved) return;
            //避免框选结束后再触发行点击，导致刚选中的行被取消
            this.justDragged = true;
            setTimeout(() => {
                this.justDragged = false;
            }, 50);
            const rect = {
                left: Math.min(start.x, e.clientX),
                right: Math.max(start.x, e.clientX),
                top: Math.min(start.y, e.clientY),
                bottom: Math.max(start.y, e.clientY),
            };
            const rows = this.$refs.procTable.$el.querySelectorAll(".el-table__body tr");
            rows.forEach((tr, index) => {
                const r = tr.getBoundingClientRect();
                const hit = !(r.left > rect.right || r.right < rect.left || r.top > rect.bottom || r.bottom < rect.top);
                const row = this.table_data[index];
                if (hit && row) this.$refs.procTable.toggleRowSelection(row, true);
            });
        },
        //页码发生变化时
        change_data(e) {
            this.search_obj.currentPage = e;
            this.get_data();
        },
        //修改每页大小
        handleSizeChange(e) {
            this.search_obj.pageSize = e;
            this.search_obj.currentPage = 1;
            this.get_data();
        },
        //状态颜色
        status_color(row) {
            if (row.statusName == "未发货") return "info";
            else if (row.statusName == "部分发货") return "warning";
            else if (row.statusName == "在途" || row.statusName == "部分签收") return "";
            else if (row.statusName == "签收完成") return "success";
        },
        gotoItem(row) {
            const { href } = this.$router.resolve({
                path: "/procSend_detail",
                query: {
                    row: JSON.stringify(row),
                },
            });
            window.open(href, "_blank");
        },
        //勾选表格数据后，批量打印所选送货单的物料标识卡
        printLabelCard() {
            const rows = (this.$refs.procTable && this.$refs.procTable.selection) || [];
            if (!rows.length) {
                this.$alert("请先勾选需要打印标识卡的送货单", "提示", { type: "warning" });
                return;
            }
            const { href } = this.$router.resolve({
                path: "/procSendLabel",
                query: {
                    formCode: rows.map((row) => row.formCode),
                },
            });
            window.open(href, "_blank");
        },
        search() {
            this.search_obj.currentPage = 1;
            this.get_data();
        },
        async_projectId(query) {
            get_project(this, query);
        },
        async_procSupplier(query) {
            get_procSupplier(this, query);
        },
        async_procMaterial(query) {
            get_procMaterial(this, query);
        },
        other_search() {
            this.search();
            this.other_show = false;
        },
        delForm(row) {
            this.$confirm(
                `送货单编号：${row.formCode}
            </br>加工商：${row.procSupplier?.supplierName}`,
                "确认删除整张送货单？",
                {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                    dangerouslyUseHTMLString: true,
                }
            )
                .then(() => {
                    delProcSendApi(row.formCode, this)
                        .then(() => {
                            this.get_data();
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },

        exportAll_submit() {
            this.$refs.exportAll.validate((valid) => {
                if (valid) {
                    this.$confirm(`时间范围：</br>${this.exportAll_data.startCreateTime}--${this.exportAll_data.endCreateTime}`, "确认批量导出excel？", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                        dangerouslyUseHTMLString: true,
                    })
                        .then(() => {
                            const loading = this.$loading({
                                lock: true,
                                text: "正在加载...",
                                spinner: "el-icon-loading",
                                background: "rgba(0, 0, 0, 0.7)",
                            });
                            getOutSourceSendItemApi(this.exportAll_data, this)
                                .then((res) => {
                                    this.expExcel(res.records);
                                    this.exportAll_show = false;
                                })
                                .catch(() => {});
                        })
                        .catch(() => {});
                }
            });
        },
        expExcel(data) {
            if (data.length == 0) {
                this.$alert("表格无数据", "异常导出", { type: "warning" });
                return;
            }
            let titleList = [
                "单据编号",
                "委派方",
                "加工方",
                "合同号",
                "项目名称",
                "建单时间",
                "审批时间",
                "签收时间",
                "图号",
                "组件名称",
                "零件号",
                "零件名称",
                "备注",
                "发货数量",
                "签收数量",
                "单价",
                "发货金额(元)",
                "签收金额（元）",
            ];
            let rows = [];
            data.forEach((item, index) => {
                let tem = [
                    item.formCode,
                    this.$store.state.companyId == "LFWZ" ? "广东凌丰五金装备科技股份有限公司" : this.$store.state.companyId == "NTLD" ? "南通立德装备科技有限公司" : "",
                    item.procSupplier?.supplierName,
                    item.project?.trackNumber,
                    item.projectName,
                    item.createTime,
                    item.auditTime,
                    item.finishTime,
                    item.mapCode,
                    item.headMaterial,
                    item.material?.materialCode,
                    item.material?.materialName,
                    item.remark,
                    item.qty,
                    item.arrivedQty,
                    item.unitPrice,
                    item.totalPrice,
                    parseFloat((item.arrivedQty * item.unitPrice).toFixed(3)),
                ];
                rows.push(tem);
            });
            exportExcel3(titleList, rows, `加工送货对账单${this.$getTime()}.xlsx`);
        },
        countFileType(name) {
            if (name.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp)$/)) return "图片";
            if (name.toLowerCase().match(/\.(pdf)$/)) return "PDF";
            return name.split(".").pop();
        },
        formatFileSize(bytes) {
            if (bytes === 0) return "0 B";
            const k = 1024;
            const sizes = ["B", "KB", "MB", "GB"];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
        },
        previewFile(file, row) {
            this.currentRow = structuredClone(row);
            const fileType = this.countFileType(file.originalName);

            if (fileType === "PDF") {
                fileApi
                    .viewFileApi(file.id, this)
                    .then((blob) => {
                        const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
                        const newWindow = window.open(blobUrl, "_blank");
                        if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
                            this.$message.warning("弹出窗口被阻止，请允许浏览器弹出窗口或手动下载后查看");
                            // 备选方案：创建下载链接
                            this.downloadBlob(blob, file.originalName);
                        }
                    })
                    .catch(() => {});
            } else if (fileType === "图片") {
                this.currentFileName = file.originalName;
                this.currentFilePath = file.id;
                this.img_show = true;
            } else if (["doc", "docx", "xls", "xlsx"].includes(file.originalName.split(".").pop().toLowerCase())) {
                this.currentViewFile = file;
                this.viewOffice = true;
            }
        },
        // 下载Blob
        downloadBlob(blob, filename) {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }, 100);
        },
        downloadFile(file) {
            fileApi
                .viewFileApi(file.id, this)
                .then((blob) => {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = file.originalName;
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => {
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    }, 100);
                    this.$message.success(`开始下载: ${file.originalName} (${this.formatFileSize(file.size)})`);
                })
                .catch(() => {
                    this.$message.error("文件下载失败，请重试");
                });
        },
        delFile(file) {
            this.$confirm("确定删除该文件吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    fileApi
                        .delFileApi(file.id, this)
                        .then(() => {
                            this.$message.success("删除成功");
                            this.get_data();
                        })
                        .catch(() => {
                            this.$message.error("删除失败");
                        });
                })
                .catch(() => {});
        },
    },
    mounted() {
        this.showTime();
    },
    created() {
        this.get_data();
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = "";
        }
        document.removeEventListener("mousemove", this.onTableMouseMove);
        document.removeEventListener("mouseup", this.onTableMouseUp);
    },
};
</script>
<style scoped>
.audit-progress-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.audit-progress-cell .el-progress {
    flex: 1;
    min-width: 0;
}

.audit-progress-text {
    width: 34px;
    text-align: right;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.reject-reason-icon {
    margin-left: 2px;
    color: #f56c6c;
    cursor: help;
    font-size: 14px;
    vertical-align: -1px;
}

.reject-reason-content {
    max-height: 200px;
    overflow-y: auto;
    font-size: 13px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-all;
}

.proc_nav {
    display: flex;
    align-items: center;
    padding: 0 15px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
}

.nav_left {
    width: 78%;
}

.nav_right {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    justify-content: center;
    width: 22%;
    flex-wrap: wrap;
}

.header-text-left {
    height: 38px;
    line-height: 38px;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}

.pe-header-text {
    margin-left: 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 45px;
    color: rgba(255, 255, 255, 0.9);
}

.header-right {
    font-size: 13px;
    height: 19px;
    line-height: 25px;
    text-align: right;
    padding-right: 15px;
    color: rgba(255, 255, 255, 0.85);
}

.header-right:first-child {
    font-weight: 500;
}

.table-body {
    /* height: 80%; */
    flex: 1;
    padding: 15px;
}

.table-footer {
    height: 5%;
    display: flex;
    padding-left: 15px;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
}

.page_footer {
    height: 2% !important;
    font-size: 13px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

/deep/.el-table .sort-caret.ascending {
    border-bottom-color: #fff;
}

/deep/.el-table .ascending .sort-caret.ascending {
    border-bottom-color: #d5d9dd;
}

/deep/.el-table .sort-caret.descending {
    border-top-color: #fff;
}

/deep/.el-table .descending .sort-caret.descending {
    border-top-color: #d5d9dd;
}

.nav_left >>> .el-descriptions-item__cell {
    padding: 4px 5px !important;
    /* line-height: 2.5; */
}

.bg {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.bg >>> .el-table .cell {
    padding: 8px 5px;
}

/* 鼠标框选时的选区矩形 */
.drag-select-box {
    position: fixed;
    z-index: 3000;
    background: rgba(120, 181, 236, 0.25);
    border: 1px dashed #409eff;
    pointer-events: none;
}
</style>
<style>
.el-table__body tr:hover > td {
    background-color: #c0ddaf !important;
}

.selected-row > td {
    background-color: #c0ddaf !important;
}

.table-body .el-table .el-checkbox {
    transform: scale(1.5);
}

.el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.185);
    border-radius: 5px;
}

.gen_data .el-table__body-wrapper::-webkit-scrollbar {
    width: 5px !important;
    height: 0 !important;
}
</style>